const BreadcrumbData = {
    'cart': [
        {
            id: '1',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '2',
            routeLabel: 'cart',
            route: '/cart'
        }
    ],
    'api_details': [
        {
            id: '3',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '4',
            routeLabel: 'api listing',
            route: '/marketplace'
        }
    ],
    //------------------breadCrump based on groups---------------------
    'group_details': [
        {
            id: '3',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '4',
            routeLabel: 'group listing',
            route: '/marketplace'
        }
    ],
    'orders_summary': [
        {
            id: '5',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '6',
            routeLabel: 'order summary',
            route: '/orders'
        }
    ],
    'legal_formalities': [
        {
            id: '7',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '8',
            routeLabel: 'Legal Formalities',
            route: '/production/legal-and-formalities'
        }
    ],
    'commercials': [
        {
            id: '7',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '8',
            routeLabel: 'Commercials',
            route: '/production/commercials'
        }
    ],
    'checkout': [
        {
            id: '9',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '10',
            routeLabel: 'Checkout',
            route: '/production/checkout'
        }
    ],
    'requests': [
        {
            id: '11',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '12',
            routeLabel: 'Requests',
            route: '/support/requests'
        }
    ],
    'profile': [
        {
            id: '13',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '14',
            routeLabel: 'Profile',
            route: '/user/profile'
        }
    ],
    'wishlist': [
        {
            id: '15',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '16',
            routeLabel: 'My Wishlist',
            route: '/wishlist'
        }
    ],
    'live': [
        {
            id: '17',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '18',
            routeLabel: 'live APIs',
            route: '/api-listing/live'
        }
    ],
    'request': [
        {
            id: '20',
            routeLabel: 'home',
            route: '/'
        },
        {
            id: '21',
            routeLabel: 'All Requests',
            route: '/support/requests'
        }
    ]
}

export default BreadcrumbData